import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadRoutes = async () => {
  try {
    const response = await Axios.get('routes');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneRoute = async (seo) => {
  try {
    const respnse = await Axios.get('routes/'+seo);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadRoute = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/routes');
        const responseData = await response.data;
        return {...responseData, route: {} };
        
      default:
        const data = await loadOneRoute(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useRoutesAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('routes', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('route_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('routes/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useRoutesAPI;


